import React from 'react';
import {userStore} from '../stores/user';

const userStoreContext = React.createContext(userStore);
export const useUser = () => React.useContext(userStoreContext);
